module.exports = __webpack_public_path__ + "img/ceshui.c503c4ad.png";